export const NoItemsIcon = () => {
  return (
    <svg
      width="102"
      height="119"
      viewBox="0 0 102 119"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>No Items</title>
      <path d="M101.999 91.3374H32.7852V0H79.6939L101.999 22.6534V91.3374Z" fill="#FF8373" />
      <path d="M102 22.6534H79.6943V0" fill="#F54D42" />
      <path d="M69.2702 118.998H0V27.6055H46.9648L69.2702 50.3146V118.998Z" fill="#D4A1FF" />
      <path
        d="M77.5088 106.813C74.8747 101.859 72.5208 97.5174 70.223 93.1203C69.5505 91.8401 68.6538 90.8939 67.3648 90.1703C63.0494 87.8326 58.7901 85.3836 54.0264 82.6563C57.7253 80.5412 60.9758 78.3705 64.5066 76.7563C68.0373 75.1422 70.2791 72.6375 71.9044 69.131C73.5296 65.6244 75.4912 62.3405 77.5648 58.5C80.1428 63.3424 82.5527 67.6838 84.7945 72.0809C85.523 73.4724 86.4758 74.4743 87.8769 75.1979C92.1923 77.5356 96.4516 79.9846 101.047 82.6006C96.3955 85.2166 92.1362 87.6656 87.8769 90.0033C86.4758 90.7825 85.523 91.7288 84.7945 93.1203C82.4967 97.6287 80.0868 101.97 77.5088 106.813Z"
        fill="#1D1D1B"
      />
      <path d="M69.2703 50.3146H46.9648V27.6055" fill="#9563FF" />
    </svg>
  );
};
